"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var facebook = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 448 1000", fill: "currentColor", width: size || '1em', height: size || '1em' }, props),
        React.createElement("path", { fill: "currentColor", d: "M414 499H288v490H100V499H11V326h89V214c0-80 35-205 189-205l139 1v168H328c-17 0-40 9-40 47v101h143l-17 173z" })));
};
facebook.displayName = 'facebook';
exports.default = facebook;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=facebook.js.map